import { useTranslation } from 'react-i18next';
import { PricingContainer, Heading, CardRow, Card, CardTitle, CardTitleBorder, CardPrice, CardPriceSubHeading, CardBulletList, BulletListItem, BulletListCheckMark, CardButton, ArrowIcon } from './PricingComponents';

function Pricing() {
  const { t } = useTranslation();

  return (
   <>
        <PricingContainer id="pricingSection">
          <Heading>{t('pricing.heading')}</Heading>
          <CardRow>
          <Card>
            <CardTitle>{t('pricing.monthly')}</CardTitle>
            <CardTitleBorder/>
            <CardPrice>$5</CardPrice>
            <CardPriceSubHeading>{t('pricing.perMonth')}</CardPriceSubHeading>
            <CardBulletList>
                  <BulletListItem><BulletListCheckMark/>{t('pricing.feature1')}</BulletListItem>
                  <BulletListItem><BulletListCheckMark/>{t('pricing.feature2')}</BulletListItem>
                  <BulletListItem><BulletListCheckMark/>{t('pricing.feature3')}</BulletListItem>
            </CardBulletList>
            <CardButton to={"/login"}>
              {t('pricing.cta')} <ArrowIcon/>
            </CardButton>
          </Card>
          <Card>
            <CardTitle>{t('pricing.annual')}</CardTitle>
            <CardTitleBorder/>
            <CardPrice>$50</CardPrice>
            <CardPriceSubHeading>{t('pricing.perYear')}</CardPriceSubHeading>
            <CardBulletList>
                  <BulletListItem><BulletListCheckMark/>{t('pricing.feature1')}</BulletListItem>
                  <BulletListItem><BulletListCheckMark/>{t('pricing.feature2')}</BulletListItem>
                  <BulletListItem><BulletListCheckMark/>{t('pricing.feature3')}</BulletListItem>
            </CardBulletList>
            <CardButton to={"/login"}>
              {t('pricing.cta')} <ArrowIcon/>
            </CardButton>
          </Card>
          </CardRow>
        </PricingContainer>
   </>
  );
}
export default Pricing;